import { CLIENT_GLOBAL_KEY, PROCESS_KEY } from '../constants'

const SHARED_TRANSLATIONS_KEY = '__shared_translations__' as const

/**
 *
 * Retrieves the client translations script for a given locale and routeName from globalThis["i18n"].translationsInlineCodeByRoute if it exists
 * Otherwise, builds it and populates globalThis["i18n"].translationsInlineCodeByRoute
 * @example "window.__BackmarketTranslations = {"translations":{"home-title":"Home","click-cta":"Click",...}};
 */
export function getTranslationsScript({
  locale,
  routeName,
  translationKeysByRoute,
}: {
  locale: string
  routeName: string
  translationKeysByRoute: Record<string, string[]>
}) {
  const { translationsInlineCodeByRoute } = globalThis[PROCESS_KEY]
  const hasRoute = routeName in (translationsInlineCodeByRoute || {})

  if (!hasRoute) {
    translationsInlineCodeByRoute[routeName] = {}
  }

  const hasLocale = locale in (translationsInlineCodeByRoute[routeName] || {})
  if (hasLocale) {
    return translationsInlineCodeByRoute[routeName][locale]
  }

  const routeTranslationsKeys = translationKeysByRoute[routeName] || []
  const sharedTranslationsKeys =
    translationKeysByRoute[SHARED_TRANSLATIONS_KEY] || []

  const routeTranslations: Record<string, string> = {}
  for (const key of [...routeTranslationsKeys, ...sharedTranslationsKeys]) {
    routeTranslations[key] =
      globalThis[PROCESS_KEY].translationsByLocale[locale]?.[key] || ''
  }

  const translationsScript = `window.${CLIENT_GLOBAL_KEY} = ${JSON.stringify({ translations: routeTranslations })};`

  translationsInlineCodeByRoute[routeName][locale] = translationsScript

  return translationsScript
}
